/* eslint-disable consistent-return */

import React from 'react';
import { ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { parse, format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DrugOverdoses from './drug-overdoses';
import TreatmentReferral from './treatment-referral';
import SurvivorInteraction from './survivor-interaction';
import OtherInteraction from './other-interaction';
import CrisisIntervention from './crisis-intervention';

const ListGroupItemMedicalEvents = ({
  params, data, includePatient, medicalEvent,
}) => {
  const destination = () => {
    if (data.isForeign) return;

    const patientUid = params
      ? params.patient_id
      : data.relationships.summaryPatient.attributes.patientUid;

    switch (data.attributes.medicalEventName) {
      case 'cit':
        return `/patients/${patientUid}/medical-events/${medicalEvent.attributes.medicalEventName}/${data.id}/cit-details`;
      default:
        return `/patients/${patientUid}/medical-events/${medicalEvent.attributes.medicalEventName}/${data.id}/details`;
    }
  };

  return (
    <ListGroupItem
      action={!data.isForeign}
      tag={!data.isForeign ? Link : 'div'}
      to={destination}
      className="d-flex justify-content-between align-items-center"
    >
      <span>
        {data.isForeign && <FontAwesomeIcon icon="external-link-alt" className="text-primary mr-2" />}

        <strong>{data.attributes.eventDate && format(parse(data.attributes.eventDate.split('+')[0]), 'MM/DD/YY')}</strong>

        {includePatient && (
          <em>
            {' '}
            {data.relationships.summaryPatient.attributes.lastName},{' '}
            {data.relationships.summaryPatient.attributes.firstName}
          </em>
        )}

        {data.attributes.medicalEventName === 'drug_overdose' && (
          <DrugOverdoses
            data={data}
          />
        )}

        {data.attributes.medicalEventName === 'survivor_interaction' && (
          <SurvivorInteraction
            data={data}
          />
        )}

        {data.attributes.medicalEventName === 'treatment_referral' && (
          <TreatmentReferral
            data={data}
          />
        )}

        {data.attributes.medicalEventName === 'other_interaction' && (
          <OtherInteraction
            data={data}
          />
        )}
        {data.attributes.medicalEventName === 'cit' && (
          <CrisisIntervention
            data={data}
          />
        )}
      </span>

      {!data.isForeign && (
        <span>
          <FontAwesomeIcon icon="chevron-right" className="text-muted" />
        </span>
      )}
    </ListGroupItem>
  );
};

ListGroupItemMedicalEvents.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  includePatient: PropTypes.bool,
  medicalEvent: PropTypes.shape().isRequired,
  params: PropTypes.shape().isRequired,
};

ListGroupItemMedicalEvents.defaultProps = {
  includePatient: false,
};

export default ListGroupItemMedicalEvents;
